import * as Icons from "lucide-react";
import { SERVICES, COMPANY } from "../lib/constants";

export default function Services() {
  return (
    <section id="servicos" data-testid="services-section" className="py-20 md:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center max-w-3xl mx-auto mb-16 reveal">
          <p className="text-sm font-bold uppercase tracking-[0.25em] text-[#00C7A5] mb-4">
            Nossos Serviços
          </p>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-[#2F5887] leading-tight mb-5">
            Soluções contábeis completas, sob medida para o seu negócio
          </h2>
          <p className="text-[#4B5563] text-lg leading-relaxed">
            Atuamos em todas as áreas da contabilidade com excelência técnica, agilidade e atendimento personalizado.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          {SERVICES.map((s, i) => {
            const Icon = Icons[s.icon] || Icons.Briefcase;
            return (
              <div
                key={i}
                data-testid={`service-card-${i}`}
                className="reveal group relative bg-white rounded-2xl p-8 border border-gray-100 hover:border-[#00C7A5]/30 transition-all duration-500 hover:-translate-y-2 card-glow overflow-hidden"
                style={{ transitionDelay: `${i * 60}ms` }}
              >
                {/* Decorative corner */}
                <div className="absolute top-0 right-0 w-32 h-32 bg-gradient-to-br from-[#00C7A5]/10 to-transparent rounded-bl-full opacity-0 group-hover:opacity-100 transition-opacity duration-500" />

                <div className="relative">
                  <div className="w-16 h-16 rounded-2xl bg-[#F5F7FA] group-hover:bg-[#00C7A5] flex items-center justify-center mb-6 transition-all duration-300">
                    <Icon className="w-8 h-8 text-[#00C7A5] group-hover:text-white transition-colors" />
                  </div>

                  <h3 className="text-xl lg:text-2xl font-bold text-[#111111] mb-3 group-hover:text-[#2F5887] transition-colors">
                    {s.title}
                  </h3>
                  <p className="text-[#4B5563] leading-relaxed mb-6 text-[15px]">{s.desc}</p>

                  <a
                    data-testid={`service-cta-${i}`}
                    href={COMPANY.whatsappLink}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex items-center gap-2 text-sm font-semibold uppercase tracking-wider text-[#2F5887] group-hover:text-[#00C7A5] transition-colors"
                  >
                    Saiba mais
                    <Icons.ArrowRight className="w-4 h-4 transition-transform group-hover:translate-x-1" />
                  </a>
                </div>
              </div>
            );
          })}

          {/* Big CTA card */}
          <div className="reveal relative rounded-2xl p-8 bg-gradient-to-br from-[#2F5887] to-[#1C3B61] text-white overflow-hidden">
            <div className="absolute -top-10 -right-10 w-48 h-48 bg-[#00C7A5]/20 rounded-full blur-3xl" />
            <div className="relative flex flex-col h-full justify-between">
              <div>
                <Icons.Sparkles className="w-10 h-10 text-[#00C7A5] mb-5" />
                <h3 className="text-2xl font-bold mb-3">Precisa de uma solução personalizada?</h3>
                <p className="text-white/85 mb-8 leading-relaxed">
                  Nossa equipe está pronta para desenhar uma estratégia contábil sob medida para o seu negócio.
                </p>
              </div>
              <button
                data-testid="services-final-cta"
                onClick={() => document.getElementById("contatos")?.scrollIntoView({ behavior: "smooth" })}
                className="inline-flex items-center justify-center gap-2 bg-[#00C7A5] hover:bg-[#00A88A] text-white font-semibold uppercase tracking-wide px-6 py-3.5 rounded-full transition-all hover:-translate-y-0.5 self-start"
              >
                Solicitar atendimento
                <Icons.ArrowRight className="w-4 h-4" />
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
